import { UserRightsMessages, TranslationUserRightsMessages } from "../interfaces/userRightsMessages";

export const messages: TranslationUserRightsMessages = {
  [UserRightsMessages.launcher]: "Home",
  [UserRightsMessages.rightsControl]: "Rights control",
  [UserRightsMessages.selectTenant]: "Select tenant",
  [UserRightsMessages.userControl]: "User control",
  [UserRightsMessages.roleDashboardTabCaption]: "Groups",
  [UserRightsMessages.roleDashboardPageTitle]: "User rights control",
  [UserRightsMessages.createRoleTabCaption]: "Create group",
  [UserRightsMessages.editRoleTabCaption]: "Edit group",
  [UserRightsMessages.createUserTabCaption]: "Create user",
  [UserRightsMessages.editUserTabCaption]: "Edit user",
  [UserRightsMessages.usersWithoutRole]: "Users without group",
  [UserRightsMessages.noRoleOrUserRegistered]: "No group or user registered",
  [UserRightsMessages.noSuiteAllowed]: "You do not have access to the user rights control of the Topcon suite",
  [UserRightsMessages.memberCount]: "{{count}} members",
  [UserRightsMessages.userCount]: "{{count}} users"
};